import { jsx } from 'react/jsx-runtime';
import { composeEventHandlers } from '@radix-ui/primitive';
import { useId } from '@radix-ui/react-id';
import { useLayoutEffect } from '@radix-ui/react-use-layout-effect';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Label as Label$1 } from '../../../label/Label.mjs';
import { Typography } from '../../../typography/Typography.mjs';
import WhenValidGrandChildren from '../../../utility/WhenValidGrandChildren.mjs';
import useWithLabelProps from '../../hooks/useWithLabelProps.mjs';
import { baseLabel } from '../baseLabel.vanilla.mjs';
import { isSlotAvailable } from '../model.mjs';
import { useTextAreaContext } from './context.mjs';
import { styledLabel } from './label.vanilla.mjs';

const TEXT_AREA_LABEL_NAME = "TextAreaLabel";
const Label = forwardRef(
  ({ id, onClick, ...props }, forwardedRef) => {
    const labelId = useId(id);
    const { size, required, disabled, state, textAreaElement, setLabelledBy } = useTextAreaContext(TEXT_AREA_LABEL_NAME);
    const handleClick = composeEventHandlers(onClick, (event) => {
      if (event.isDefaultPrevented()) {
        return;
      }
      window.requestAnimationFrame(() => textAreaElement?.focus());
    });
    useLayoutEffect(() => {
      setLabelledBy(labelId);
    }, [labelId, setLabelledBy]);
    const slotAvailable = isSlotAvailable(size);
    const restLabelProps = useWithLabelProps(props, size);
    const LabelImpl = slotAvailable ? Label$1 : BasicLabel;
    return /* @__PURE__ */ jsx(WhenValidGrandChildren, { children: /* @__PURE__ */ jsx(
      LabelImpl,
      {
        ...restLabelProps,
        id: labelId,
        disabled,
        state,
        size,
        required,
        ref: forwardedRef,
        onClick: handleClick
      }
    ) });
  }
);
const BasicLabel = forwardRef(
  ({ children, ...props }, ref) => {
    return /* @__PURE__ */ jsx(StyledLabel, { ...props, ref, children: /* @__PURE__ */ jsx(Typography, { ellipsis: true, children }) });
  }
);
const StyledLabel = forwardRef(
  ({
    className: classNameFromProps,
    disabled,
    required,
    state,
    size,
    ...props
  }, forwardedRef) => {
    return /* @__PURE__ */ jsx(
      "span",
      {
        className: classNames(
          baseLabel({ disabled, required, state }),
          styledLabel({ size }),
          classNameFromProps
        ),
        ref: forwardedRef,
        ...props
      }
    );
  }
);

export { Label as default };
//# sourceMappingURL=Label.mjs.map
